module.exports = __webpack_public_path__ + "static/media/citystay-title.7230c980.jpg";